import React from 'react';
import { BodyText, Heading } from '../../atoms';
import { PageHeaderTitleWrapper } from './PageHeaderTitle.styles';
import { PageHeaderSize } from '../PageHeader/type';

export type PageHeaderTitleProps = {
  /**
   * Title text
   */
  title: string;
  /**
   * Text size
   */
  size: PageHeaderSize;
};

const PageHeaderTitle = ({ title, size }: PageHeaderTitleProps) => {
  return (
    <PageHeaderTitleWrapper>
      <div data-testid="page-title">
        {size === 'small' ? (
          <BodyText variant="body2" color="inherit">
            {title}
          </BodyText>
        ) : (
          <Heading variant="h3" color="inherit">
            {title}
          </Heading>
        )}
      </div>
    </PageHeaderTitleWrapper>
  );
};

export default PageHeaderTitle;
